interface OnetrustScript {
    OptanonWrapper: () => void;
    OnetrustActiveGroups: string;
    OneTrust: any;
}

declare global {
    interface Window extends OnetrustScript {
        dataLayer?: unknown[];
    }
}

export default defineNuxtPlugin(() => {
    const runtimeConfig = useRuntimeConfig();

    let gtmReady = Promise.resolve(false);

    if (runtimeConfig.public.onetrust.apiKey && runtimeConfig.public.gtm.id) {
        try {
            // GTM Script
            // only loaded after Cookie Consent
            const { load: loadGTM, onLoaded: onLoadedGTM } = useScriptGoogleTagManager({
                id: runtimeConfig.public.gtm.id,
                scriptOptions: {
                    trigger: 'manual',
                },
            });

            // Create a Promise and resolve it when GTM is loaded
            let gtmReadyResolve: (enabled: boolean) => void;
            gtmReady = new Promise<boolean>((resolve) => {
                gtmReadyResolve = resolve;
            });
            onLoadedGTM(() => {
                gtmReadyResolve(true);

                // Page View
                useScriptEventPage(({ title, path }) => {
                    analyticsTrackPageView(title, path, false);
                });

                const route = useRoute();
                analyticsTrackPageView(document.title, route.fullPath, true);
            });

            // OneTrust Script, used to load GTM after Cookie Consent and show Cookie Banner
            useScript({
                'src': 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
                'data-domain-script': runtimeConfig.public.onetrust.apiKey,
            });

            // Load GTM after Cookie Consent
            window.OptanonWrapper = function () {
                const consentGroups = ['C0004', 'C0002'];
                if (consentGroups.some(group => window.OnetrustActiveGroups?.includes(group))) {
                    loadGTM();
                }
            };
        }
        catch (error) {
            handleError(error, false);
        }
    }

    return {
        provide: {
            gtmReady,
        },
    };
});
